import ReactGA from 'react-ga4';

export const trackButtonClick = (label: string) => {
  ReactGA.event({
    action: `${label}_button_click`,
    category: 'button_click'
  });
};